import axios from 'axios'
import { ref } from 'vue'

export function useInformationRequests({
    onDeleted = () => {},
    onError = () => {},
}) {
    const deleting = ref(false)

    const deleteInformationRequest = async (id) => {
        try {
            deleting.value = true
            await axios.delete(`/api/information-requests/${id}`)
            onDeleted()
        } catch (error) {
            onError(error)
        } finally {
            deleting.value = false
        }
    }

    return {
        deleting,
        deleteInformationRequest,
    }
}
